export const RESOURCE_TYPE = 'RESOURCE_TYPE_CONTEXTUAL_SUMMARY_FETCH_ATLASSIAN_ACCOUNT_TRAITS';
export const RESOURCE_KEY = 'contextual-summary-fetch-atlassian-account-traits-resource-key';
export const ANALYTICS_ID = 'useResource.fetchContextualSummaryAtlassianAccountTraits';
